export default {
  computed: {
    // Dynamic slot checker
    hasSlot() {
      return (slotName) => {
        return !!(this.$scopedSlots?.[slotName] || this.$slots?.[slotName]);
      };
    },
  },
};